module.exports = __webpack_public_path__ + "static/img/cruelty_child_1_tc.73c1d87d.png";